import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { jsonrpc } from '~/shared/api/jsonrpc'
import { Box, Header } from '~/shared/ui'
import { useZone } from '~/team_tools/components/timezone'
import { CALENDAR, PeriodFigures } from '~/team_tools/dashboard/statistic/figures'
import { useWindowParams } from '~/team_tools/dashboard/statistic/period'

export const AccountsCount = () => {
    const [accounts, setAccounts] = useState<Record<string, [number, number]>>({})
    // "Today", "Week" and "Month" are days in the zone the shell names, and
    // change with it.
    const [zone] = useZone()

    // Fetched in full, shown as the tab asks. One call either way, so the
    // window control is instant and costs the server nothing.
    const window = useWindowParams()
    const periods = ['total', 'today', 'week', 'month', '24_hours', '7_days', '30_days'].concat(
        window.custom ? ['custom'] : []
    )

    const [history, setHistory] = useState<Record<string, [number, number]>>({})

    useEffect(() => {
        let live = true
        jsonrpc('statistic.accounts.count', { periods, tz: zone, ...window.figure }).then(
            (resp) => live && setAccounts(resp.result || {})
        )
        setHistory({})
        jsonrpc('statistic.accounts.count.history', { ...window.history, tz: zone }).then(
            (resp) => live && setHistory(resp.result || {})
        )
        return () => {
            live = false
        }
    }, [zone, window.key])

    const count = (period: string) => {
        const [registered] = accounts[period] || []
        return registered !== undefined ? registered.toLocaleString('en-US') : undefined
    }
    const activated = (period: string) => {
        const [, active] = accounts[period] || []
        return active !== undefined ? `${active.toLocaleString('en-US')} activated` : undefined
    }

    return (
        <Box className='w-full text-center'>
            <Header>Accounts</Header>
            <div className='text-xs text-white/40'>
                Public players: staff, test and fraud-tagged accounts excluded.
            </div>
            <PeriodFigures
                periods={CALENDAR}
                loading={accounts.total === undefined}
                value={count}
                note={activated}
                total={{
                    label: 'All time',
                    value: count('total'),
                    note: activated('total'),
                    as: <NavLink to='/team-tools/accounts' className='hover:outline' />,
                }}
                chart={{
                    lines: [
                        {
                            label: 'Registrations',
                            colour: '#fff',
                            history: Object.fromEntries(Object.entries(history).map(([day, [v]]) => [day, v])),
                        },
                        {
                            // By signup day: no activation timestamp is stored.
                            label: 'Of which activated',
                            colour: 'rgb(34, 197, 94)',
                            history: Object.fromEntries(Object.entries(history).map(([day, [, a]]) => [day, a])),
                        },
                    ],
                }}
            />
        </Box>
    )
}
